<template>
    <div>
        {{  currentTabProp }}
      <component :is="currentTab" />
    </div>
  </template>
  
  <script>
  import CostTable from "./modules/CostTable.vue";
  import ManualCostTable from "./modules/ManualCostTable.vue";
  import UpgradeSubscription from "./modules/UpgradeSubscription.vue";
  
  export default {
    props: ['currentTabProp'],
    components: { CostTable, ManualCostTable, UpgradeSubscription },
    data() {
      return {
       
      };
    },
    computed: {
      currentTab() {
        let screen = "";
        switch (this.currentTabProp) {
          case "default":
            screen = "cost-table";
            break;
          case "manual":
            screen = "manual-cost-table";
            break;
          default:
            screen = "cost-table";
            break;
        }
        return screen;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
  